import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoDuzlemSecici } from './FikoDuzlemSecici';
import { FikoSecimListesi } from './FikoSecimListesi';

/**
 * Generic Definition penceresi (FikoDialogCore içeriği) — Pad/Hole gibi ÖZEL penceresi olmayan
 * tüm feature'lar (Mirror/Simetri/Taşı/Döndür/Ölçek/Dizi/Kabuk/Eğim/Fillet/Pah/Loft/Sweep...) için.
 * Parametreler merkezi `featureDialogParametreler()`'den gelir (Sayı/Açılır). Canlı rebuild.
 */
@Component({
  selector: 'fikoyt-feature-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, FikoDuzlemSecici, FikoSecimListesi],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">Parametreler</div>
      @for(p of params(); track p.isim){
        @if(p.turu === 'SecimListe'){
          <fikoyt-secim-listesi [element]="el" [yonetici]="yon" [tip]="p.secimTip"></fikoyt-secim-listesi>
        } @else {
        <div class="sd-row"><label>{{ p.isim }}</label>
          @if(p.turu === 'Açılır'){
            <select [ngModel]="p.degeri" (ngModelChange)="p.degisti($event)">
              @for(o of (p.ayar?.secenekler || []); track o.deger){ <option [value]="o.deger">{{ o.etiket }}</option> }
            </select>
          } @else if(p.turu === 'Metin'){
            <input class="sd-metin" type="text" [ngModel]="p.degeri" (ngModelChange)="p.degisti($event)"/>
          } @else if(p.turu === 'Onay'){
            <input type="checkbox" [ngModel]="!!p.degeri" (ngModelChange)="p.degisti($event)" class="sd-chkbox"/>
          } @else if(p.turu === 'Düzlem'){
            <fikoyt-duzlem-secici [element]="el" [yonetici]="yon"></fikoyt-duzlem-secici>
          } @else if(p.turu === 'DuzlemSnap'){
            <fikoyt-duzlem-secici [element]="el" [yonetici]="yon" [anahtar]="p.anahtar" [tur]="'duzlem'" [mod]="'komut'"></fikoyt-duzlem-secici>
          } @else if(p.turu === 'Eksen'){
            <fikoyt-duzlem-secici [element]="el" [yonetici]="yon" [anahtar]="p.anahtar" [tur]="'eksen'" [mod]="'komut'"></fikoyt-duzlem-secici>
          } @else if(p.turu === 'Aksiyon'){
            <button class="sd-aksiyon" [class.aktif]="yon?.kenarSecimAktif || yon?.yuzSecimAktif" (click)="p.tiklandi()">{{ p.isim }}</button>
          } @else if(p.turu === 'Ref3D'){
            <div class="sd-ref">
              <select [ngModel]="p.degeri" (ngModelChange)="p.degisti($event)">
                <option [value]="-1">— seç —</option>
                @for(o of (p.ayar?.secenekler || []); track o.deger){ <option [value]="o.deger">{{ o.etiket }}</option> }
              </select>
              <button class="sd-ref-btn" [class.aktif]="yon?.refSecAktif && yon?.refSecHedef?.()===p.anahtar" (click)="ref3d(p)" title="3D sahneden seç (tıkla)">🎯</button>
            </div>
          } @else {
            <div class="sd-num">
              <input type="number" [ngModel]="p.degeri" (ngModelChange)="setNum(p, $event)"
                     [step]="p.ayar?.adim || 1" [min]="p.ayar?.min ?? null" [max]="p.ayar?.maks ?? null"/>
              @if(p.ayar?.birim){ <span>{{ p.ayar.birim }}</span> }
            </div>
          }
        </div>
        }
      }
      @if(!params().length){ <div class="sd-bos">Bu özellik geometri/profil seçimiyle düzenlenir.</div> }
    </div>
    <div class="sd-altbar">
      <button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button>
      <button class="sd-btn sd-sil" (click)="sil()">🗑 Sil</button>
    </div>
  </div>
  `,
  styles: [`
    .sd{padding:6px 10px 10px;color:#dbe4f0;font:500 12px/1.4 system-ui,sans-serif;min-width:225px;}
    .sd-grup{padding:4px 0 3px;}
    .sd-bas{font-size:10px;font-weight:800;color:#7db0ff;text-transform:uppercase;letter-spacing:.5px;margin:0 0 6px;}
    .sd-row{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:4px 0;}
    .sd-row label{font-size:11.5px;color:#aab8cc;}
    .sd-row select{flex:1;max-width:150px;background:rgba(10,20,35,.85);color:#fff;border:1px solid rgba(0,200,255,.35);border-radius:5px;padding:3px 5px;font-size:11px;cursor:pointer;outline:none;}
    .sd-num{display:flex;align-items:center;gap:4px;}
    .sd-num input{width:64px;background:rgba(0,0,0,.4);color:#fff;font-weight:700;border:none;border-bottom:1px solid rgba(0,200,255,.5);border-radius:3px;padding:2px 5px;text-align:right;outline:none;}
    .sd-num input:focus{border-bottom-color:#00d0ff;background:rgba(0,60,80,.5);}
    .sd-num span{color:#00d0ff;font-size:10px;}
    .sd-chkbox{accent-color:#00d0ff;cursor:pointer;width:15px;height:15px;}
    .sd-metin{flex:1;max-width:150px;background:rgba(0,0,0,.4);color:#fff;border:1px solid rgba(0,200,255,.5);border-radius:4px;padding:3px 6px;font-size:11px;font-family:monospace;outline:none;}
    .sd-metin:focus{border-color:#00d0ff;background:rgba(0,60,80,.5);}
    .sd-ref{display:flex;align-items:center;gap:5px;flex:1;max-width:160px;}
    .sd-ref select{flex:1;background:rgba(10,20,35,.85);color:#fff;border:1px solid rgba(0,200,255,.35);border-radius:5px;padding:3px 5px;font-size:11px;cursor:pointer;outline:none;}
    .sd-ref-btn{flex:0 0 26px;background:rgba(56,189,248,.15);border:1px solid rgba(56,189,248,.4);border-radius:5px;cursor:pointer;padding:2px;font-size:13px;line-height:1;}
    .sd-ref-btn:hover{background:rgba(56,189,248,.35);}
    .sd-ref-btn.aktif{background:rgba(250,204,21,.25);border-color:rgba(250,204,21,.7);animation:sdNabiz 1s infinite;}
    .sd-aksiyon{flex:1;background:rgba(56,189,248,.15);border:1px solid rgba(56,189,248,.4);border-radius:6px;color:#cfe6f5;cursor:pointer;padding:5px 8px;font-size:11.5px;font-weight:600;}
    .sd-aksiyon:hover{background:rgba(56,189,248,.3);}
    .sd-aksiyon.aktif{background:rgba(250,204,21,.25);border-color:rgba(250,204,21,.7);animation:sdNabiz 1s infinite;}
    @keyframes sdNabiz{0%,100%{box-shadow:0 0 0 0 rgba(250,204,21,.4);}50%{box-shadow:0 0 0 4px rgba(250,204,21,0);}}
    .sd-bos{font-size:11px;color:#8593a8;font-style:italic;padding:4px 0;}
    .sd-btn{width:100%;margin-top:4px;background:rgba(20,40,60,.7);color:#cfe6f5;border:1px solid rgba(0,200,255,.3);border-radius:6px;padding:5px;font-size:11.5px;font-weight:600;cursor:pointer;transition:all .15s;}
    .sd-btn:hover{background:rgba(0,150,200,.4);border-color:#00d0ff;}
    .sd-altbar{display:flex;gap:6px;margin-top:8px;}
    .sd-altbar .sd-btn{margin-top:0;}
    .sd-ok{background:rgba(20,120,80,.55);border-color:rgba(52,211,153,.5);color:#a7f3d0;}
    .sd-ok:hover{background:rgba(20,160,100,.7);}
    .sd-sil{flex:0 0 70px;background:rgba(120,30,30,.5);border-color:rgba(239,68,68,.5);color:#fca5a5;}
    .sd-sil:hover{background:rgba(160,40,40,.7);}
  `]
})
export class FikoFeatureDialog implements OnDestroy {
  @Input() element: any;   // IOzellik
  @Input() yonetici: any;  // FikoModellemeYonetici
  @Input() pencere: any;   // FikoDialogCore
  get el() { return this.element; }
  get yon() { return this.yonetici; }

  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }   // X/kapanış dâhil seçim modunu kökten temizle

  params(): any[] { return this.yonetici?.featureDialogParametreler?.(this.element) || []; }
  setNum(p: any, v: any): void { const n = +v; if (!isNaN(n)) p.degisti(n); this.CD.markForCheck(); }
  ref3d(p: any): void { this.yonetici?.komutRefSec?.(this.element, p.anahtar, p.tipler || ['nokta3d'], () => this.CD.markForCheck()); }

  private kapat(): void { (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}
